/*=========================================================================================
  File Name: moduleActivityActions.js
  Description: Activity Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix Masa
==========================================================================================*/

import Api from "@/helpers/api.js";
import Activity from "@/models/Activity.js";

export default {
	addActivityItem({commit, dispatch}, activity) {
		return new Promise((resolve, reject) => {
			Api.post("/activity", activity)
				.then((response) => {
					const newActivity = new Activity(activity);
					commit("ADD_ACTIVITY_ITEM", Object.assign(newActivity, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchIssuesListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/manualdata")
				.then((response) => {
					commit("SET_ISSUES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchIssuesListItemsByIdUploadedFile({commit}, uploadedFileId) {
		return new Promise((resolve, reject) => {
			Api.get(`/manualdata/${uploadedFileId}`)
				.then((response) => {
					commit("SET_ISSUES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/activity/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateManualdataVisitpoint({commit}, {manual_data_id, visit_point}) {
		return new Promise((resolve, reject) => {
			Api.put(`/manualdata/visitpoint/${manual_data_id}`, visit_point)
				.then((response) => {
					commit("REMOVE_MANUAL_DATA_ITEM", manual_data_id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateManualdataResource({commit}, {manual_data_id, resource_data}) {
		return new Promise((resolve, reject) => {
			Api.put(`/manualdata/resource/${manual_data_id}`, resource_data)
				.then((response) => {
					commit("REMOVE_MANUAL_DATA_ITEM", manual_data_id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateManualdataEvent({commit}, {register, id}) {
		return new Promise((resolve, reject) => {
			Api.put(`/manualdata/event/${id}`, {...register})
				.then((response) => {
					commit("REMOVE_MANUAL_DATA_ITEM", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeManualdataItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/manualdata/${itemId}`)
				.then((response) => {
					commit("REMOVE_MANUAL_DATA_ITEM", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchFormsActivityList({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/forms/list")
				.then((response) => {
					commit("SET_FORMS_ACTIVITIES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
